<div class="flex-header mat-dialog-title" translate>
  Edit Document
</div>
<div class="flex-content">
  <form [formGroup]="editDocumentForm" #formDir="ngForm">
    <div>
      <tyl-form-field #fileCategoryInput [errorMessage]="fileCategoryErrorMessage" label="Category" class="selectField" style="width: 100%">
        <mat-select aria-label="Category" id="selectCategory" formControlName="fileCategory" required>
          <mat-option *ngFor="let category of portfolioCategories" [value]="category.StuPortCategory_ID" translate>{{category.StuPortCategoryName}}</mat-option>
        </mat-select>
      </tyl-form-field>
    </div>
    <div>
      <tyl-form-field [errorMessage]="fileCategoryErrorMessage" label="Description" style="width: 100%">
        <input matInput aria-label="Description" id="documentDescription" formControlName="fileDescription" type="text" required>
      </tyl-form-field>
    </div>
  </form>
</div>
<div class="flex-footer">
  <div class="flex-footer-right">
    <tyl-button image="save.png" label="Save" (clickEvent)="saveClick()" translate></tyl-button>
    <tyl-button image="cancel.png" label="Cancel" (clickEvent)="closeClick()" translate></tyl-button>
  </div>
</div>
